import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import moment from 'moment'
Vue.use(Vuex)

var value2 = moment(new Date()).subtract(1, 'months').format('YYYY/MM');

export default new Vuex.Store({
  state: {
    num: 1,
    responeList: [],
    FilterList:[],
    verId:'',
    orgId:'',
    selectedItem:[],
    stepOne: {
      uploadList: [],
      value: "",
      value2: value2,
      salaryType: ''
    },
    stepTwo: {
      content: '',
      selectId: '',
    },
    stepThree: {
      nowHtml: '',
      // step3发送方式开关
      switch: true,//邮箱
      switch2: true,//短信
      switch3: true,//微信
      isSign: true,
      isNotice: false,
      sendNotice: '',
      incinerate:false,//签后即焚
      incinerateTime:'',//签后即焚时间
      incinerateType:'',//签后即焚时间类型
      data: {
        data: ['']
      },
      total: 0,
      activeindex: '',
      autoNotice: false
    },
    modifyName: false,
    orderStep: 1,
    orderPayType: 0,
    isPackage: false,
    payState: 'recharge',
    packageDetail: '',
    invoiceInfo: '',
    invoiceAddressId: '',
    vipActiveData: [],
    isPayDone: false,
    setpTwoStr: '',
    userAuth: '',
    userTplNum: 0,
    UserTemplateList: [],
    stepTwoShowState: 'portrait',
    isModify: false,
    customTemplate: "", //用户模板
    defaultTemplate: "", //默认模板
    smssign: '',
    nullflag: false,
    zeroFlag: false,
    verify:false,
    showTip: false,
    vipshowTip: false,
    smstipFlag: false,

    // lovecard
    previewUrl: '',
    canvasWidth: 1242,
    canvasHeight: 2208,
    editstate: 1,
    canvasJson: '',
    // 
    backList: {
      flag: false,
      msg: ''
    },
    packageNumflag: {
      num: 0
    },
    sendFlag: true,
    childItem:[],//工资条隐藏列
    sendLoading: false,
    useInfo:{}//登录信息
  },
  mutations: {
    setchildItem(state,payload){
      state.childItem = payload
    },
    setsendLoading (state, payload) {
      state.sendLoading = payload
    },
    setGZT (state, payload) {
      state.selectedItem = payload
    },
    setsendFlag (state, payload) {
      state.sendFlag = payload
    },
    setpackageNumflag (state, payload) {
      state.packageNumflag = payload
    },
    setbackList (state, payload) {
      state.backList = payload
    },
    setstepQuery (state, payload) {
      state.responeList.query = payload
    },
    setcanvasJson (state, payload) {
      state.canvasJson = payload
    },
    seteditstate (state, payload) {
      state.editstate = payload
    },
    setcanvasHeight (state, payload) {
      state.canvasHeight = payload
    },
    setcanvasWidth (state, payload) {
      state.canvasWidth = payload
    },
    setpreviewUrl (state, payload) {
      state.previewUrl = payload
    },
    setsmstipFlag (state, payload) {
      state.smstipFlag = payload
    },
    setvipshowTip (state, payload) {
      state.vipshowTip = payload
    },
    setshowTip (state, payload) {
      state.showTip = payload
    },
    setzeroFlag (state, payload) {
      state.zeroFlag = payload
    },
    setnullflag (state, payload) {
      state.nullflag = payload
    },
    getsmssign (state, payload) {
      state.smssign = payload
    },
    getuserTplNum (state, payload) {
      state.userTplNum = payload
    },
    getUserTemplateList (state, payload) {
      state.UserTemplateList = payload
    },
    delUserTemplateList (state, payload) {
      state.UserTemplateList.forEach((item, index) => {
        if (item.id == payload) {
          state.UserTemplateList.splice(index, 1);
        }
      })
    },
    getUserAuth (state, payload) {
      state.userAuth = payload
    },
    setpTwoStr (state, payload) {
      state.setpTwoStr = payload
    },
    handleVip (state, payload) {
      state.orderStep = 2
      state.isPackage = true
      state.vipActiveData = payload.list
      state.packageDetail = payload.detail

    },
    setPayDone (state, payload) {
      state.isPayDone = payload
    },
    setInvoiceInfo (state, payload) {
      state.invoiceInfo = payload
    },
    setInvoInvoiceAddress (state, payload) {
      state.invoiceAddressId = payload
    },
    orderStepBack (state) {
      state.orderStep = 1
      state.vipActiveData = []
      state.packageDetail = ''
      state.isPackage = false
    },
    activeStep (state, payload) {
      state.orderStep < 3 ? state.orderStep++ : null
      !payload.package ? state.orderPayType = payload.orderType : state.isPackage = true
      payload.package ? state.orderPayType = payload.orderType : state.orderPayType = payload.orderType
      payload.package ? state.packageDetail = payload.packageDetail : ''
    },
    modifyName (state, payload) {
      state.modifyName = payload
    },
    add (state) {
      state.num++
    },
    clearSteps (state, payload) {
      state.stepOne = {
        uploadList: [],
        value: "",
        value2: "",
        salaryType: ''
      }
      state.stepTwo = {
        content: '',
        selectId: '',
      }
      state.stepThree = {
        nowHtml: '',
        switch: true,
        switch2: true,
        switch3: true,
        isSign: true,
        isNotice: false,
        sendNotice: '',
        data: {
          data: ['']
        },
        total: 0
      }
    },
    
    getUploadList (state, payload) {
      state.stepOne.uploadList = payload
    },
    getFilterList (state, payload) {
      state.FilterList = payload
    },
    getList (state, payload) {
      state.responeList = payload
    },
    getverId (state, payload) {
      state.verId = payload
    },
    getorgId (state, payload) {
      state.orgId = payload
    },
    getsalaryType (state, payload) {
      state.stepOne.salaryType = payload
    },
    getContent (state, payload) {
      state.stepTwo.content = payload.content
      state.stepTwo.selectId = payload.id
    },
    getStepThreeData (state, payload) {
      state.stepThree.data = payload
    },
    getSetpThreeHtml (state, payload) {
      state.stepThree.nowHtml = payload
    },
    getSetpThreeActive (state, payload) {
      state.stepThree.activeindex = payload
    },
    getSetpThreeTotal (state, payload) {
      state.stepThree.total = payload
    },
    changeEmailSwitch (state, payload) {
      state.stepThree.switch = payload
    },
    changeSmsSwitch (state, payload) {
      state.stepThree.switch2 = payload
    },
    changeWxSwitch (state, payload) {
      state.stepThree.switch3 = payload
    },
    changeVerifySwitch (state, payload) {
      state.verify = payload
    },
    changeIsSign (state, payload) {
      state.stepThree.isSign = payload
    },
    changeClickSign (state, payload) {
      state.stepThree.clickSign = payload
    },
    changeIsNotice (state, payload) {
      state.stepThree.isNotice = payload
    },
    changeIncinerate (state, payload) {
      state.stepThree.incinerate = payload
    },
    changeIncinerateTime (state, payload) {
      state.stepThree.incinerateTime = payload
    },
    changeIncinerateType (state, payload) {
      state.stepThree.incinerateType = payload
    },
    changeautoNotice (state, payload) { },
    changeSendNotice (state, payload) {
      state.stepThree.sendNotice = payload
    },
    changeIsmodify (state, payload) {
      state.isModify = payload
    },
    changeCustomTemplate (state, payload) {
      state.customTemplate = payload
    },
    changeDefaultTemplate (state, payload) {
      state.defaultTemplate = payload
    },
   setUseInfo (state, payload) {
     state.useInfo = payload
    },

  },
  actions: {
    getContent (store, payload) {
      if (process.env.NODE_ENV == 'development') {
        axios.get(`http://192.168.0.20:9091/pst-salary-api/v1/template/${payload}`).then(res => {
          store.commit('getContent', res.data.data)
        })
      } else {
        axios.get(`http://47.99.180.106/pst-salary-api/v1/template/${payload}`).then(res => { store.commit('getContent', res.data.data) })
      }
    }
  }
})
